export const formatPrice = (price: number) => {
    return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
    }).format(price);
};

//ĐỊNH DẠNG SỐ TIỀN
export const formatCurrency = (value: any) => {
    if (value == null) {
        return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
        minimumFractionDigits: 0, // Không hiển thị phần thập phân
        maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
};